module.exports = __webpack_public_path__ + "assets/img/7_1077_big.113bbe32.jpg";